import api from "./api";

const getSigns = (search) => {

  return api.get("/sign",{
    params: {
      ...search
    }
  })
  .then((response) => {
    return response.data;
  });
};

const getSignMessages = (search) => {

  return api.get("/sign/message",{
    params: {
      ...search
    }
  })
  .then((response) => {
    return response.data;
  });
};

const getSignMessage = (id) => {

  return api.get("/sign/message/"+id)
  .then((response) => {
    return response.data;
  });
};

const updateSignMessage = (message) => {
  return api.patch("/sign/message",
  {
    ...message
  })
  .then((response) => {
    return response.data;
  });
};

const createSignMessage = (message) => {
  return api.post("/sign/message",
  {
    ...message
  })
  .then((response) => {
    return response.data;
  });
};


const getSignImages = (search) => {

  return api.get("/sign/image",{
    params: {
      ...search
    }
  })
  .then((response) => {
    return response.data;
  });
};

const getSignImage = (id) => {

  return api.get("/sign/image/"+id)
  .then((response) => {
    return response.data;
  });
};

const updateSignImage = (message) => {
  return api.patch("/sign/image",
  {
    ...message
  })
  .then((response) => {
    return response.data;
  });
};

const createSignImage = (message) => {
  return api.post("/sign/image",
  {
    ...message
  })
  .then((response) => {
    return response.data;
  });
};


const getSign = (id) => {

  return api.get("/sign/"+id)
  .then((response) => {
    return response.data;
  });
};

const updateSign = (sign) => {
  return api.patch("/sign",
  {
    ...sign
  })
  .then((response) => {
    return response.data;
  });
};

const setSignColour = (id,red,green,blue) => {
  return api.get("/sign_change_colour",
  { params: 
  {
    id: id,
    red: red,
    green: green,
    blue: blue,
  }})
  .then((response) => {
    return response.data;
  });
};

const setSignBrightness = (id,brightness) => {
  return api.get("/sign_change_brightness",
  { params: 
  {
    id: id,
    brightness: brightness
  }})
  .then((response) => {
    return response.data;
  });
};

const setSignMode= (id,mode) => {
  return api.get("/sign_change_mode",
  { params: 
  {
    id: id,
    mode: mode
  }})
  .then((response) => {
    return response.data;
  });
};

const setSignMessage = (id,messageID) => {
  return api.get("/sign_change_message",
  { params: 
  {
    id: id,
    message: messageID
  }})
  .then((response) => {
    return response.data;
  });
};

const setSignImage = (id,imageID) => {
  return api.get("/sign_change_image",
  { params: 
  {
    id: id,
    image: imageID
  }})
  .then((response) => {
    return response.data;
  });
};

const SignService = {
  getSigns,
  getSign,
  updateSign,
  setSignColour,
  setSignBrightness,
  setSignMode,
  getSignMessage,
  getSignMessages,
  updateSignMessage,
  setSignMessage,
  createSignMessage,
  getSignImage,
  getSignImages,
  updateSignImage,
  setSignImage,
  createSignImage,
};

export default SignService;